import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { PlusIcon, ImageIcon, CheckCircleFilledIcon, CautionFilledIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default from 'react';
import Image from './Image.js';
import ProgressBar from './ProgressBar.js';
import Spinner from './Spinner.js';
import Tooltip from './Tooltip.js';

var _excluded = ["alt", "className", "percentComplete", "src", "success", "type", "errorText", "fileName"];
var Thumbnail = function Thumbnail(props) {
  var alt = props.alt,
    className = props.className,
    percentComplete = props.percentComplete,
    src = props.src;
    props.success;
    var type = props.type,
    errorText = props.errorText,
    fileName = props.fileName,
    otherProps = _objectWithoutProperties(props, _excluded);
  var finalClasses = classnames('C-Thumbnail', {
    '--withBackground': src || percentComplete || type || fileName
  }, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: finalClasses
  }, otherProps), src && /*#__PURE__*/React__default.createElement(Image, {
    width: "100%",
    src: src,
    alt: alt || 'thumbnail image'
  }), !src && type !== 'loading' && !fileName && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "C-Thumbnail__iconAdd fa-layers"
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Thumbnail__iconAdd--Plus",
    size: "lg",
    icon: PlusIcon
  })), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Thumbnail__icon",
    size: "xl",
    icon: ImageIcon
  })), fileName && !src && /*#__PURE__*/React__default.createElement("div", {
    className: "C-Thumbnail__fileName",
    "aria-label": 'image filename'
  }, fileName), type === 'loading' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: "hc-sr-only"
  }, "Content is loading..."), /*#__PURE__*/React__default.createElement("div", {
    className: "C-Thumbnail__loading"
  }, /*#__PURE__*/React__default.createElement(Spinner, {
    size: "dense"
  }), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, "Uploading..."))), type === 'success' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Thumbnail__stateIcon --type-success",
    size: "sm",
    icon: CheckCircleFilledIcon,
    tabIndex: -1
  }), /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: "hc-sr-only"
  }, "Upload successful.")), type === 'error' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, errorText ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Tooltip, {
    className: "C-Thumbnail__stateIcon",
    location: "top-right",
    tabIndex: "0",
    tooltip: errorText
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "--type-error",
    size: "sm",
    icon: CautionFilledIcon
  })), /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: "hc-sr-only"
  }, "Upload error.")) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Thumbnail__stateIcon --type-error",
    size: "sm",
    icon: CautionFilledIcon
  }), /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: "hc-sr-only"
  }, "Upload error."))), !!(percentComplete && percentComplete !== 100) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ProgressBar, {
    percentComplete: percentComplete
  }), /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: "hc-sr-only"
  }, "Upload ", percentComplete, "% complete.")));
};
Thumbnail.displayName = 'Thumbnail';

export { Thumbnail as default };
